import { render, staticRenderFns } from "./BbcsOrderStatus.vue?vue&type=template&id=66995c2d&scoped=true&"
import script from "./BbcsOrderStatus.vue?vue&type=script&lang=js&"
export * from "./BbcsOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./BbcsOrderStatus.vue?vue&type=style&index=0&id=66995c2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66995c2d",
  null
  
)

/* custom blocks */
import block0 from "./BbcsOrderStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports